"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomInteger = exports.randomString = void 0;
const randomString = () => {
    return Math.random().toString(36).substr(2, 7);
};
exports.randomString = randomString;
/**
 * Generate a random integer between two points (inclusive)
 * @param min minimum number (inclusive)
 * @param max maximum number (inclusive)
 * @returns randomly generated integer
 */
const randomInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
exports.randomInteger = randomInteger;
